var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 61,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2003",
    "data-name": "Rect\\xE1ngulo 2003",
    width: 28.554,
    height: 28.758,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1437",
    "data-name": "Grupo 1437",
    transform: "translate(-1602 -13687.284)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_132",
    "data-name": "Elipse 132",
    cx: 35,
    cy: 35.5,
    rx: 35,
    ry: 35.5,
    transform: "translate(1607 13692.284)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_134",
    "data-name": "Elipse 134",
    transform: "translate(1602 13687.284)",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 40,
    ry: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 39.5,
    ry: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1436",
    "data-name": "Grupo 1436",
    transform: "translate(1629.446 13712.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1435",
    "data-name": "Grupo 1435",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1595",
    "data-name": "Trazado 1595",
    d: "M140.528,130.112a9.212,9.212,0,0,1,1.536-1.442,6.206,6.206,0,0,1,2.749-.99,9.452,9.452,0,0,1,3.854.216,5.663,5.663,0,0,1,3.831,3.61,13.621,13.621,0,0,1,.791,4.948c.027,3.205.015,6.411.016,9.617a.934.934,0,0,1-1.053,1.068q-2.053.009-4.106,0a.937.937,0,0,1-1.053-1.069c0-3.014,0-6.027,0-9.041a7.009,7.009,0,0,0-.383-2.368c-.844-2.359-3.995-2.29-5.114-.8a5.333,5.333,0,0,0-1.06,3.261c-.017,2.941-.005,5.883-.006,8.824,0,.874-.318,1.2-1.189,1.2q-1.891,0-3.782,0c-.771,0-1.115-.348-1.115-1.125q0-8.518,0-17.037c0-.766.356-1.112,1.128-1.113q1.945,0,3.89,0a.955.955,0,0,1,1.067,1.065c0,.394,0,.788,0,1.181",
    transform: "translate(-124.753 -118.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1596",
    "data-name": "Trazado 1596",
    d: "M18.255,141.187q0,4.176,0,8.352c0,.956-.319,1.276-1.271,1.277q-1.8,0-3.6,0c-.849,0-1.2-.358-1.2-1.2q0-8.424,0-16.848c0-.868.355-1.222,1.223-1.222q1.836,0,3.672,0c.822,0,1.179.357,1.18,1.187q0,4.23,0,8.46",
    transform: "translate(-11.301 -122.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1597",
    "data-name": "Trazado 1597",
    d: "M3.934,7.842A3.921,3.921,0,1,1,7.849,3.917,3.907,3.907,0,0,1,3.934,7.842",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.79c7c4e0139e31b3b1434ac76b6f5a58.svg";
export { ForwardRef as ReactComponent };